<template>
    <div style="min-width:1000px;">
        <div class="aboutus  animated fadeInUp">
            <div>
                <p class="company">公司介绍</p>
            </div>
            <div @click="$router.push('/announcement')">
                <p  class="company">加入我们</p>
            </div>
        </div>
        <div
            ref="about"
            style="min-width:1000px;"
        >
            <div
                class="about"
                id="about"
            >
                <div>
                    <el-row class="row-bg">
                        <el-col
                            :xs="24"
                            class="animated fadeInLeft"
                            :lg="10"
                            style="padding-left:30px"
                        >
                            <img
                                src="../assets/img/about.png"
                                style="width:100%"
                                alt
                            >
                        </el-col>
                        <el-col
                            :xs="24"
                            :lg="14"
                            class="animated fadeInRight"
                        >
                            <div class="textdetaile animated fadeInDown">
                                <div>
                                    <p class="text">云智停车是为车主、车场、运营者提供服务的综合性服务网站。</p>
                                    <p class="text">公司始终不渝地奉行“以人为本 以客户为中心”的宗旨; </p>
                                    <p> 秉承“诚信合作 规范服务 创新发展”的服务理念;</p>
                                    <p> 我们怀揣着火一样的热情，不懈努力、顽强拼搏;</p>
                                    <p> 公司各项业务取得了长足的发展，打造了公司品牌，也服务了社会。</p>
                                </div>

                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div>
        <div
            id="aboutus"
            style="min-width:1000px;"
        >
            <div class="about_text">

                <p>昆明市智慧停车建设运营有限公司</p>
            </div>
            <div class="detaile">
                <p>经昆明市政府、省国资委和中国船舶重工集团公司批准，由昆明交通产业股份有限公司、昆明船舶设备集团有限公司、昆明钢铁控股有限公司共同出资组建昆明市智慧停车建设运营有限公司。公司主要依托股东公司拥有投融资优势、AGV技术、自动控制系统技术及机械式停车设备制造、安装、改造技术，结合互联网、物联网技术运用，构建立足昆明，面向全国的利用先进技术运营停车及衍生业务的高科技公司。公司成立时间为2017年1月18日，公司注册资金2亿元整。</p>

            </div>
        </div>
        <div class="yw">

            <h5>业务范围</h5>
            <p>公司主要业务包括以收购、租赁或合营现有停车场并引入AGV技术等先进手段进行运营管理；自建或合作建设AGV智慧化停车场、机械式立体停车库；承接市场上智慧化停车场新建、改造的设计安装、建设施工及运营管理业务；手机终端APP停车服务大数据平台建设及大数据开发业务及停车场配套商业开发、物业管理、户外广告、汽车充电等衍生业务。</p>

        </div>

    </div>
</template>

<script>
import about from './about';
export default {
  components: {
    about,
  },
  name: 'aboutus',
};
</script>

<style scoped>
/* #aboutus {
    background-image: url("../assets/img/gsyw.jpg");
    background-size: 100% 100%;
    background-repeat: no-repeat;
} */
.yw {
  /* max-width: 1200px; */
  margin: 0 auto;
  padding: 30px;
}
h5 {
  font-size: 1.2rem;
  font-weight: 700;
  color: #364167;
  line-height: 50px;
  text-transform: capitalize;
}
.about {
  max-width: 1400px;
  min-width: 1000px;
  margin: 0 auto;
}
.yw {
  margin: 0 auto;
  max-width: 1400px;
  padding-bottom: 100px;
}
.yw p {
  font-size: 16px;
  line-height: 35px;
  color: #90a0b4;
  padding-right: 15px;
  text-transform: capitalize;
}
.aboutus {
  width: 100%;
  height: 480px;
  background-image: url('../assets/img/aboutus.png');
  background-size: 100% 100%;
  background-repeat: no-repeat;
  color: #ffffff;
  font-size: 25px;
}
.company {
  float: right;
  margin-top: 250px;
  margin-right: 80px;
}
.about_text {
  width: 100%;
  margin: 0 auto;
  text-align: center;
}
.about_text :first-child {
  font-size: 16px;
  padding: 20px;
}
.about_text :last-child {
  width: auto;
  font-size: 16px;
  margin-bottom: 10px;
  color: #00b0d3;

  padding-bottom: 20px;
}
.detaile {
  max-width: 1400px;
  margin: 0 auto;
  font-size: 16px;
  line-height: 35px;
  color: #90a0b4;
  padding-right: 15px;
  text-transform: capitalize;
  padding-bottom: 40px;
}
.textdetaile {
  margin-top: 100px;
}
.textdetaile p {
  font-size: 18px;
  line-height: 25px;
  padding: 4px;
  letter-spacing: 2px;
}
</style>



// WEBPACK FOOTER //
// src/components/aboutus.vue